// extracted by mini-css-extract-plugin
export default {"recos":"T4-z","productCardOverride":"U4-z","rowHasBadge":"V4-z"};